import script from "./Toggle.vue?vue&type=script&setup=true&lang=js"
export * from "./Toggle.vue?vue&type=script&setup=true&lang=js"

import "./Toggle.vue?vue&type=style&index=0&id=65c2e6ea&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65c2e6ea"]])

export default __exports__